var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelationships(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2281 14.9757C13.735 14.9757 14.9566 13.7541 14.9566 12.2471C14.9566 10.7402 13.735 9.51855 12.2281 9.51855C10.7211 9.51855 9.49951 10.7402 9.49951 12.2471C9.49951 13.7541 10.7211 14.9757 12.2281 14.9757Z",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08057 20.4816H6.33057C6.33057 20.8959 6.66635 21.2316 7.08057 21.2316V20.4816ZM16.9788 20.4816V21.2316H17.7288V20.4816H16.9788ZM12.6925 14.3132H11.3669V15.8132H12.6925V14.3132ZM11.3669 14.3132C8.58215 14.3132 6.33057 16.5648 6.33057 19.3496H7.83057C7.83057 17.3932 9.41058 15.8132 11.3669 15.8132V14.3132ZM6.33057 19.3496V20.4816H7.83057V19.3496H6.33057ZM7.08057 21.2316H16.9788V19.7316H7.08057V21.2316ZM17.7288 20.4816V19.3496H16.2288V20.4816H17.7288ZM17.7288 19.3496C17.7288 16.5648 15.4773 14.3132 12.6925 14.3132V15.8132C14.6488 15.8132 16.2288 17.3932 16.2288 19.3496H17.7288Z",
    fill: "#EE2F4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7979 15.7105C20.1018 15.7105 21.1588 14.6535 21.1588 13.3497C21.1588 12.0458 20.1018 10.9888 18.7979 10.9888C17.494 10.9888 16.437 12.0458 16.437 13.3497C16.437 14.6535 17.494 15.7105 18.7979 15.7105Z",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9786 20.4816H22.9195V20.0752C22.9195 17.7046 21.0037 15.7888 18.6331 15.7888C17.6559 15.7888 16.756 16.1178 16.04 16.6596",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationships);
export default __webpack_public_path__ + "static/media/Relationships.a767191b92c90506fe43baf66f481407.svg";
export { ForwardRef as ReactComponent };